import { c as _c } from "react/compiler-runtime";
import { ProjectActions } from "@components/common/project-actions";
import { RemoveMemberMenuItem } from "@components/table/member-group-projects/remove-member-menu-item";
import { DeleteIcon } from "@flat-ui";
import { useProjectMemberActions } from "@hooks/projects/use-project-member-actions";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { isProjectAssignedThroughTeam } from "@utils/data-display";
/**
 * Project actions for the member overview page: the shared project actions plus
 * a "Remove member" option. The option is hidden when the current user lacks the
 * permission to remove members from the project, and disabled when the member's
 * access is inherited through a team or the member is the project's resource owner.
 */
export function MemberGroupProjectActions(t0) {
  const $ = _c(15);
  const {
    project,
    member,
    onMemberRemoved
  } = t0;
  let t1;
  if ($[0] !== project.id) {
    t1 = getProjectByIdSelector(project.id);
    $[0] = project.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sdbProject = useAppSelector(t1);
  const {
    canRemoveMembers
  } = useProjectMemberActions(sdbProject);
  let t2;
  if ($[2] !== project) {
    t2 = isProjectAssignedThroughTeam(project);
    $[2] = project;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isAssignedThroughTeam = t2;
  const isResourceOwner = project.role === "RESOURCE_OWNER";
  let t3;
  if ($[4] !== isAssignedThroughTeam || $[5] !== isResourceOwner || $[6] !== member || $[7] !== onMemberRemoved) {
    t3 = {
      label: "Remove member",
      Icon: DeleteIcon,
      component: (item, closeMenu) => <RemoveMemberMenuItem project={item} member={member} isAssignedThroughTeam={isAssignedThroughTeam} isResourceOwner={isResourceOwner} onRemoved={onMemberRemoved} closeMenu={closeMenu} />
    };
    $[4] = isAssignedThroughTeam;
    $[5] = isResourceOwner;
    $[6] = member;
    $[7] = onMemberRemoved;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const removeMemberItem = t3;
  let t4;
  if ($[9] !== canRemoveMembers || $[10] !== removeMemberItem) {
    t4 = canRemoveMembers ? [removeMemberItem] : [];
    $[9] = canRemoveMembers;
    $[10] = removeMemberItem;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== project || $[13] !== t4) {
    t5 = <ProjectActions project={project} contextType="member-group-project-list-view" extraMenuItems={t4} />;
    $[12] = project;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}